export const streamIsActive = {
  type: "boolean"
};
